import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

import { ApContentService } from '@ap/content';
import { ErrorMessages } from '@ap/form/errors';

import { nameAndDevicePattern } from '../tokens-browser.constants';
import { TokensBrowserService } from '../tokens-browser.service';

import content from './device.content.json';

/**
 * @module DeviceModule
 * @ngdoc component
 * @name DeviceComponent
 */
@Component({
    selector: 'tokens-browser-device',
    templateUrl: 'device.component.html',
    standalone: false
})
export class DeviceComponent implements OnInit {
    @Input()
    public device: string;

    @Output()
    public newDevice: EventEmitter<string> = new EventEmitter();

    @Output()
    public back: EventEmitter<string> = new EventEmitter();

    public form: UntypedFormGroup;
    public buttonsDisabled: boolean;

    public errorMessage: ErrorMessages;

    public constructor(
        private readonly contentService: ApContentService,
        private readonly tokensBrowserService: TokensBrowserService
    ) {}

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
        this.form = new UntypedFormGroup({
            device: new UntypedFormControl(this.device, [
                Validators.required,
                Validators.maxLength(100),
                Validators.pattern(nameAndDevicePattern)
            ])
        });
        this.tokensBrowserService.setFocusOnActiveInput('tokens-browser-device ap-input input');

        this.errorMessage = {
            required: this.contentService.get(`tokens.browser.device.error.required`),
            maxlength: this.contentService.get(`tokens.browser.device.error.maxlength`),
            pattern: this.contentService.get(`tokens.browser.device.error.pattern`)
        };
    }

    public submit(): void {
        this.buttonsDisabled = true;

        if (this.form.valid) {
            this.newDevice.emit(this.form.get('device').value);
        } else {
            this.buttonsDisabled = false;
            Object.keys(this.form.controls).forEach((field) => {
                const control = this.form.get(field);
                control.markAsTouched();
                control.markAsDirty();
            });
        }
    }

    public goBack(): void {
        this.back.emit(this.form.get('device').value);
    }

    public onBlur(): void {
        const value = this.form.get('device').value;
        const formattedValue = this.tokensBrowserService.formatSpacing(value);
        this.form.get('device').setValue(formattedValue);
    }

    public getAriaLabel(): string {
        const title = this.contentService.get('tokens.browser.device.title');
        const info = this.contentService.get('tokens.browser.device.info');
        return `${title}, ${info}`;
    }
}
